import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { Search, MapPin } from "lucide-react";

const RESULTS = [
  { name: "Inyectora 01", detail: "ENGEL · victory 220", loc: "Nave 1" },
  { name: "Inyectora 03", detail: "ENGEL · victory 550", loc: "Nave 2" },
];

export default function SearchDemo() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  const [typed, setTyped] = useState("");

  useEffect(() => {
    if (!inView) return;
    const word = "ENGEL";
    let i = 0;
    const timer = setInterval(() => {
      i += 1;
      setTyped(word.slice(0, i));
      if (i >= word.length) clearInterval(timer);
    }, 220);
    return () => clearInterval(timer);
  }, [inView]);

  const showResults = typed.length >= 3;

  return (
    <section ref={ref} className="bg-white border-y border-zinc-100" data-testid="busqueda-instantanea-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-5">Búsqueda</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-zinc-900 leading-tight">
            Encuentra antes de empezar a buscar.
          </h2>
          <p className="text-lg text-zinc-600 leading-relaxed mt-5">
            Por nombre, fabricante, modelo, número de serie o ubicación.
            También puedes organizar las máquinas por planta, nave o zona.
          </p>
        </div>

        <div className="max-w-2xl mx-auto mt-14">
          <div className="relative">
            <Search className="absolute left-5 top-1/2 -translate-y-1/2 text-zinc-400" size={20} />
            <div
              data-testid="demo-search-input"
              className="w-full h-14 pl-13 pr-5 rounded-full bg-white border border-zinc-200 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.06)] flex items-center text-lg"
              style={{ paddingLeft: "3.25rem" }}
            >
              {typed ? (
                <span className="text-zinc-900">{typed}<span className="animate-pulse text-zinc-400">|</span></span>
              ) : (
                <span className="text-zinc-400 text-base sm:text-lg">Buscar máquina, fabricante, modelo o número de serie…</span>
              )}
            </div>
          </div>

          <div className="mt-5 space-y-2.5 min-h-[148px]" data-testid="demo-search-results-list">
            {showResults &&
              RESULTS.map((r, i) => (
                <motion.div
                  key={r.name}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.35, delay: i * 0.12 }}
                  className="flex items-center gap-4 bg-white rounded-2xl border border-zinc-200/80 px-5 py-4"
                >
                  <span className="h-10 w-10 rounded-xl bg-zinc-100 flex items-center justify-center text-zinc-400 shrink-0">
                    <Search size={15} />
                  </span>
                  <div>
                    <p className="font-medium text-zinc-900">{r.name}</p>
                    <p className="text-sm text-zinc-500 flex items-center gap-1.5">
                      {r.detail} · <MapPin size={12} /> {r.loc}
                    </p>
                  </div>
                </motion.div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
